import { mergeStyleSets, getTheme } from "@fluentui/react/lib/Styling";

const theme = getTheme();

const styles = mergeStyleSets({
  stageListHeaderText: {
    color: theme.palette.neutralSecondary,
  },
  startTimeCell: {
    width: 200,
    flexShrink: 0,
  },
  stageSeperatorCell: {
    margin: 5,
    height: "100%",
    minHeight: "20px",
    borderLeft: `2px dotted ${theme.palette.neutralTertiaryAlt}`,
  },
  errorMessageBarContainer: {
    padding: 5,
    maxWidth: "100%",
  },
});

export { styles };
